import React from 'react'
import Style from './Categories.module.css'
import useAllCatergories from '../../hooks/useAllCategories'
import Loading from '../Loading/Loading'
import Error from '../Error/Error'
import {Helmet} from "react-helmet";

export default function Categories() {
  const { isLoading, isError, data } = useAllCatergories();

  return <>
 <Helmet>
      <meta charSet="utf-8" />
      <title>Categories</title>
    </Helmet>
    {isLoading && <Loading />}
    {data && <div className="row gy-3 my-3">

      {data?.data.data.map((category) => {
        return <div className='col-md-4 product '>
          <div className="card">
            <img src={category.image} height={300} alt={category.name} style={{objectFit:'cover'}} className="card-img-top" />
            <div className="card-body">
              <h3 className="card-text text-main text-center">{category.name}</h3>
            </div>
          </div>

        </div>
      })}

    </div>}
    {isError && <Error />}
  </>
}
